var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86272 3.86345C5.26924 2.45692 7.17689 1.66675 9.16602 1.66675C11.1551 1.66675 13.0628 2.45692 14.4693 3.86345C15.8758 5.26997 16.666 7.17762 16.666 9.16675C16.666 10.8761 16.0825 12.5253 15.0258 13.848L18.0886 16.9108C18.414 17.2363 18.414 17.7639 18.0886 18.0893C17.7632 18.4148 17.2355 18.4148 16.9101 18.0893L13.8472 15.0265C12.5245 16.0832 10.8754 16.6667 9.16602 16.6667C7.17689 16.6667 5.26924 15.8766 3.86272 14.47C2.45619 13.0635 1.66602 11.1559 1.66602 9.16675C1.66602 7.17762 2.45619 5.26997 3.86272 3.86345ZM9.16602 3.33341C7.61892 3.33341 6.13519 3.948 5.04123 5.04196C3.94726 6.13592 3.33268 7.61965 3.33268 9.16675C3.33268 10.7138 3.94726 12.1976 5.04123 13.2915C6.13519 14.3855 7.61892 15.0001 9.16602 15.0001C10.7131 15.0001 12.1968 14.3855 13.2908 13.2915C14.3848 12.1976 14.9993 10.7138 14.9993 9.16675C14.9993 7.61965 14.3848 6.13592 13.2908 5.04196C12.1968 3.948 10.7131 3.33341 9.16602 3.33341Z",
    fill: "#A5AAAF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d1863cc30ebcaf35b4a96908cf386c13.svg";
export { ForwardRef as ReactComponent };